export enum WidgetGroupType {
    unspecfic
}